/** @format */

import styled from 'styled-components';

export const PinSingleIconContainer = styled.button`
  border: none;
  background-color: transparent;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 34px;
    height: 34px;
  }
`;

export const PinIconContainer = styled.button<{ $selected?: boolean | null }>`
  display: inline-flex;
  padding: 0.375rem 0.875rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 5rem;
  border: 1px solid var(--gray-300);
  background: var(--white);
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  transition: all 0.3s ease;
  cursor: pointer;

  span {
    color: var(--gray-900);
    text-align: right;
    font-family: ${({ theme }) => theme.font.body};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.25rem;
    display: flex;
    gap: 4px;
    svg {
      transition: all 0.3s ease;
    }
  }

  &:hover {
    transform: scale(1.088);
    transition: all 0.3s ease;
  }
  &.active {
    border: 1px solid var(--dark-teal-300, #4d8a91);
    background: var(--dark-teal-600, #015962);
  }

  ${({ $selected }) =>
    $selected &&
    `
    transform: scale(1.088);
    border: 1px solid var(--dark-teal-300, #4d8a91);
    background: var(--dark-teal-600, #015962);
    transition: all 0.3s ease;

    span {
      color: var(--white);
      transition: all 0.3s ease;
    }
  `}
`;
